import styled from 'styled-components';
import { colors } from '@/styles';

export const ExpandContainer = styled.div<{ $isExpanded: boolean; $maxHeight: number }>`
  max-height: ${({ $isExpanded, $maxHeight }) => ($isExpanded ? 'none' : `${$maxHeight}px`)};
  overflow: hidden;
  position: relative;
`;

export const ExpandGradient = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 30px;
  background: linear-gradient(to bottom, transparent, ${colors.primary.white});
  pointer-events: none;
`;
